import { useState } from "react";
import { X } from "@phosphor-icons/react";

export function EditorPickerModal({ task, members, onClose, onConfirm }) {
  const videoEditors = members.filter((m) => m.role === "video_editor");
  const [selected, setSelected] = useState(task?.video_editor_id || "");
  const [submitting, setSubmitting] = useState(false);

  const confirm = async () => {
    setSubmitting(true);
    await onConfirm(selected || null);
    setSubmitting(false);
  };

  return (
    <div className="modal-backdrop" onClick={onClose} data-testid="editor-picker-modal">
      <div className="modal" onClick={(e) => e.stopPropagation()} style={{ maxWidth: 480 }}>
        <div className="flex items-start justify-between p-6 border-b border-[color:var(--border)]">
          <div>
            <p className="label-mono">Hand off</p>
            <h2 className="font-heading text-xl font-bold tracking-tight mt-1">Send to Video Editor</h2>
            {task && (
              <p className="text-sm text-[color:var(--text-secondary)] mt-2 truncate">"{task.title}"</p>
            )}
          </div>
          <button onClick={onClose} className="text-[color:var(--text-secondary)] hover:text-white" data-testid="close-editor-picker"><X size={20} /></button>
        </div>
        <div className="p-6 space-y-2 max-h-[60vh] overflow-y-auto">
          <label
            className={`flex items-center gap-3 px-4 py-3 rounded-md border cursor-pointer transition ${
              selected === ""
                ? "border-[#007AFF] bg-[#007AFF]/10"
                : "border-[color:var(--border)] hover:bg-[color:var(--surface-hover)]"
            }`}
            data-testid="editor-option-any"
          >
            <input
              type="radio"
              name="editor"
              value=""
              checked={selected === ""}
              onChange={() => setSelected("")}
              className="accent-[#007AFF]"
            />
            <div>
              <p className="font-semibold text-sm">Any video editor</p>
              <p className="text-xs text-[color:var(--text-secondary)]">First available editor picks it up.</p>
            </div>
          </label>
          {videoEditors.length === 0 ? (
            <p className="text-sm text-[color:var(--text-tertiary)] py-4 text-center">
              No video editors in this project yet. Pick "Any video editor" — an admin can invite one later.
            </p>
          ) : (
            videoEditors.map((m) => {
              const active = selected === m.id;
              return (
                <label
                  key={m.id}
                  data-testid={`editor-option-${m.id}`}
                  className={`flex items-center gap-3 px-4 py-3 rounded-md border cursor-pointer transition ${
                    active
                      ? "border-[#A855F7] bg-[#A855F7]/10"
                      : "border-[color:var(--border)] hover:bg-[color:var(--surface-hover)]"
                  }`}
                >
                  <input
                    type="radio"
                    name="editor"
                    value={m.id}
                    checked={active}
                    onChange={() => setSelected(m.id)}
                    className="accent-[#A855F7]"
                  />
                  <div>
                    <p className="font-semibold text-sm">{m.name}</p>
                    <p className="text-xs text-[color:var(--text-secondary)] font-mono">{m.email}</p>
                  </div>
                </label>
              );
            })
          )}
        </div>
        <div className="p-6 border-t border-[color:var(--border)] flex gap-3 justify-end">
          <button onClick={onClose} className="btn-ghost">Cancel</button>
          <button
            data-testid="confirm-editor-pick"
            onClick={confirm}
            disabled={submitting}
            className="btn-primary"
          >
            {submitting ? "Sending…" : "Send to editor"}
          </button>
        </div>
      </div>
    </div>
  );
}
